import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const IngredientPhilosophy = () => {
  const philosophyPoints = [
  {
    icon: "CheckCircle",
    title: "100% Halal Certified",
    description: "Every ingredient sourced from certified halal suppliers with complete traceability and transparency"
  },
  {
    icon: "Leaf",
    title: "Fresh Daily Preparation",
    description: "No frozen ingredients, no preservatives—everything prepared fresh each morning in our kitchens"
  },
  {
    icon: "Users",
    title: "Local Supplier Partnerships",
    description: "Supporting 15+ local farmers and suppliers across Karnataka for vegetables, spices, and dairy products"
  },
  {
    icon: "Globe",
    title: "Authentic Mexican Imports",
    description: "Key ingredients like dried chilies, masa harina, and spices imported directly from trusted Mexican sources"
  }];


  const ingredients = [
  {
    name: "Fresh Vegetables",
    source: "Local Karnataka Farms",
    image: "https://images.unsplash.com/photo-1670867014214-74c03f0a5bb9",
    imageAlt: "Colorful array of fresh vegetables including red tomatoes, green bell peppers, purple onions, and leafy cilantro arranged on rustic wooden table"
  },
  {
    name: "Premium Meats",
    source: "Certified Halal Suppliers",
    image: "https://images.unsplash.com/photo-1614352538250-52538a540122",
    imageAlt: "High quality raw chicken and beef cuts displayed on clean white surface with fresh herbs and spices, showing premium halal meat preparation"
  },
  {
    name: "Authentic Spices",
    source: "Mexican & Indian Origins",
    image: "https://images.unsplash.com/photo-1539821109642-3589812b0597",
    imageAlt: "Vibrant collection of ground spices in small bowls including red chili powder, yellow turmeric, brown cumin, and green herbs on dark background"
  },
  {
    name: "Fresh Dairy",
    source: "Local Dairy Cooperatives",
    image: "https://images.unsplash.com/photo-1702312685548-3832748d09d6",
    imageAlt: "Fresh dairy products including white cheese, cream, and milk in glass containers with condensation drops showing freshness on marble surface"
  }];


  return (
    <section className="py-20 bg-gradient-to-br from-primary/5 to-accent/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground mb-4">
            Our Ingredient <span className="text-primary">Philosophy</span>
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Quality ingredients are the foundation of authentic flavors
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {philosophyPoints?.map((point, index) =>
          <div
            key={index}
            className="bg-background p-8 rounded-xl border border-border hover:border-primary transition-all duration-300 hover:shadow-md animate-slide-up"
            style={{ animationDelay: `${index * 100}ms` }}>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name={point?.icon} size={24} color="var(--color-primary)" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-foreground mb-2">{point?.title}</h3>
                  <p className="text-muted-foreground leading-relaxed">{point?.description}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="bg-background rounded-2xl p-8 border border-border">
          <h3 className="text-2xl font-bold text-foreground mb-8 text-center">
            Where Our Ingredients Come From
          </h3>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {ingredients?.map((ingredient, index) =>
            <div
              key={index}
              className="group animate-fade-in"
              style={{ animationDelay: `${index * 100}ms` }}>

                <div className="relative rounded-xl overflow-hidden mb-4 h-48">
                  <Image
                  src={ingredient?.image}
                  alt={ingredient?.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                </div>
                <h4 className="text-lg font-semibold text-foreground mb-1">{ingredient?.name}</h4>
                <p className="text-sm text-muted-foreground">{ingredient?.source}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default IngredientPhilosophy;